import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollarSign, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        categoria: '',
        nombre: '',
        precio: '',
        estado: '',
        categorias: [],
        errors: [],
    }
    changeValue = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errors: [] })
    }
    errorVerify(element) {
        return this.state.errors.indexOf(element) !== -1;
    }
    sendData = (e) => {
        e.preventDefault();
        const { categoria, nombre, precio, estado } = this.state;
        var errors = [];
        if (!categoria) { errors.push("error_categoria"); }
        if (!nombre) { errors.push("error_nombre"); }
        if (!precio) { errors.push("error_precio"); }
        if (!estado) { errors.push("error_estado"); }
        console.log(errors.length);
        this.setState({ errors: errors });
        if (errors.length > 0) {
            return false;
        }
        var data = {
            categoria: categoria,
            nombre: nombre,
            precio: precio,
            estado: estado,
            id_usuario: window.localStorage.getItem('idusuario')
        }
        Swal.showLoading();
        authAxios.post("servicios/register", data)
            .then((dataResult) => {
                console.log(dataResult)
                var status = dataResult.data.status;
                if (!status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                if (dataResult.data.status) {
                    Swal.close();
                    Swal.fire(
                        'Servicios!',
                        dataResult.data.message,
                        'success'
                    )
                    this.props.history.push("/MasterServicios");
                } else {
                    Swal.close();
                    Swal.fire(
                        'Servicios!',
                        dataResult.data.message,
                        'error'
                    )
                }
            })
            .catch(console.log)
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("servicios/categorias")
            .then((dataResult) => {
                console.log(dataResult);
                var status = dataResult.data.status;
                if (!status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({
                    categorias: dataResult.data.categorias
                });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const { categoria, nombre, precio, categorias, estado } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>NUEVO SERVICIO</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.sendData}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <hr style={{ marginBottom: 0, marginTop: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN DEL SERVICIO</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-5">
                                                    <label htmlFor="categoria">Categoria</label>
                                                    <select name="categoria"
                                                        id="categoria"
                                                        className={((this.errorVerify("error_categoria")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.changeValue}>
                                                        <option value="">Seleccione la Categoria</option>
                                                        {
                                                            categorias.map((itemCategorias) => (
                                                                <option key={itemCategorias.ID_CATEGORIA} value={itemCategorias.ID_CATEGORIA}>{itemCategorias.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Categoria</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-5">
                                                    <label htmlFor="nombre">Nombre</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="nombre" id="nombre" value={nombre}
                                                        className={((this.errorVerify("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"}
                                                        placeholder="Nombre" aria-describedby="helpId" onChange={this.changeValue} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Nombre</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="precio">Precio</label>
                                                    <div className={((this.errorVerify("error_precio")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input type="number" name="precio" id="precio" value={precio}
                                                            className={((this.errorVerify("error_precio")) ? "is-invalid" : "") + " form-control form-control-sm"} maxLength={20}
                                                            placeholder="PRECIO" aria-describedby="helpId" onChange={this.changeValue} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Precio</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="estado">Estado</label>
                                                    <select name="estado"
                                                        id="estado"
                                                        className={((this.errorVerify("error_estado")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.changeValue}>
                                                        <option value="">Seleccione el Estado</option>
                                                        <option value="0">ACTIVO</option>
                                                        <option value="1">INACTIVO</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Estado</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Guardar</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterServicios"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;